import { BrowserRouter, Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { useAuth } from './lib/auth';
import { BuildingDetail } from './pages/BuildingDetail';
import { Buildings } from './pages/Buildings';
import { Companies } from './pages/Companies';
import { CompanyDetail } from './pages/CompanyDetail';
import { ContactDetail } from './pages/ContactDetail';
import { Contacts } from './pages/Contacts';
import { Dashboard } from './pages/Dashboard';
import { Goals } from './pages/Goals';
import { DealDetail } from './pages/DealDetail';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { Pipeline } from './pages/Pipeline';
import { Reminders } from './pages/Reminders';
import { Revenue } from './pages/Revenue';
import { Review } from './pages/Review';
import { SearchPage } from './pages/Search';
import { Settings } from './pages/Settings';

export function App() {
  const { session, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center"><Spinner /></div>;
  if (!session) return <Login />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/:id" element={<ContactDetail />} />
          <Route path="companies" element={<Companies />} />
          <Route path="companies/:id" element={<CompanyDetail />} />
          <Route path="buildings" element={<Buildings />} />
          <Route path="buildings/:id" element={<BuildingDetail />} />
          <Route path="pipeline" element={<Pipeline />} />
          <Route path="deals/:id" element={<DealDetail />} />
          <Route path="revenue" element={<Revenue />} />
          <Route path="goals" element={<Goals />} />
          <Route path="reminders" element={<Reminders />} />
          <Route path="review" element={<Review />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
